import * as React from 'react';
import { useDispatch } from 'react-redux';

import { applyMicrofrontendFilters } from '../../../actions/filters/applyMicrofrontendFilters';
import { TThunkDispatch } from '../../../types/redux';
import { IFiltersUpdatedEventDetail } from '../types';

const FILTERS_UPDATED_EVENT = 'filters:updated';

export function useFiltersUpdatedEvent(): void {
  const dispatch = useDispatch<TThunkDispatch>();

  React.useEffect(() => {
    const handleFiltersUpdated = (event: CustomEvent<IFiltersUpdatedEventDetail>) => {
      dispatch(applyMicrofrontendFilters(event.detail));
    };

    window.addEventListener(FILTERS_UPDATED_EVENT, handleFiltersUpdated);

    return () => {
      window.removeEventListener(FILTERS_UPDATED_EVENT, handleFiltersUpdated);
    };
  }, [dispatch]);
}
